import React, { Component } from 'react'
import ToastMessage, { toastify } from '../../components/shared/Toasts'
import FormData from 'form-data'
import { saveByteArray } from '../../utils/utilities'
import { Button } from 'react-bootstrap'
import { getCurrentSession } from '../../../lib/authentication'
import { Download, Repeat, LoaderCircle, X } from 'lucide-react'

const toastFileInvalidMessage = (
  <ToastMessage icon="exclamation">
    File uploaded is invalid. <br />
    Please check the file.
  </ToastMessage>
)

const toastFileUploadRetryMessage = (
  <ToastMessage icon="exclamation">
    Something Appears to be Wrong. <br />
    Please Retry. <br />
    For further assistance contact us through the mail icon on the bottom of the screen
    for assistance
  </ToastMessage>
)

class FileInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: false,
      valid: false,
      loading: false,
      uploaded: false,
      fileName: '',
      fileSize: 0,
      file: null,
      fileArray: [],
      removeName: '',
      downloadName: '',
      deleteLoading: false,
      downloadLoading: false,
    }

    this.handleClick = this.handleClick.bind(this)
    this.handleRemove = this.handleRemove.bind(this)
    this.handleReload = this.handleReload.bind(this)
    this.handleDownload = this.handleDownload.bind(this)
    this.addSuffix = this.addSuffix.bind(this)
    this.removeSuffix = this.removeSuffix.bind(this)
    this.formatActionColumn = this.formatActionColumn.bind(this)
    this.fileSizeHandler = this.fileSizeHandler.bind(this)
  }

  componentDidMount() {
    if (this.props.attached) {
      this.setState({
        fileName: this.props.fileName,
        fileArray: this.props.fileArray,
        selected: true,
        valid: true,
        uploaded: true,
        fileSize: this.props.fileSize,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.attached &&
      !this.props.selected &&
      nextProps.fileSize > 0 &&
      this.state.fileName === '' &&
      this.state.fileArray.length < 1 &&
      this.props !== nextProps
    ) {
      const fileName = nextProps.fileName

      let fileArray = (nextProps.fileArray || []).filter((file) => !!file.name)
      this.setState({
        fileName,
        selected: true,
        valid: true,
        uploaded: true,
        fileSize: nextProps.fileSize,
        fileArray: fileArray,
      })
    }
  }

  addSuffix(fileName, suffix) {
    return fileName.replace('.pdf', `_${suffix}.pdf`)
  }

  removeSuffix(fileName, suffix) {
    const index = fileName.lastIndexOf(suffix)
    if (index == -1) {
      return fileName
    }

    return fileName.substring(0, index) + fileName.substring(index + suffix.length)
  }

  handleClick(evt) {
    if (!evt.retry) {
      if (evt.target.files && evt.target.files[0].size <= 0) {
        toastify.error(toastFileInvalidMessage)
        return
      }
      if (!evt.target.files[0].type.includes('pdf')) {
        this.setState({
          fileName: evt.target.files[0].name,
          selected: true,
          valid: false,
        })
        this.props.onFileChange({
          id: this.props.id,
          fileSize: 0,
          attached: true,
          valid: false,
        })
        return
      }
      this.setState({
        file: evt.target.files[0],
      })
    }

    this.setState({
      valid: true,
      loading: true,
      selected: true,
    })
    for (let dataFile of evt.target.files) {
      const file = evt.retry ? this.state.file : dataFile
      const fileName = this.addSuffix(file.name, this.props.suffix)
      const renamedFile = new File([file], fileName, { type: file.type })
      const params = {
        fileName,
        submissionID: this.props.submissionID,
        revisionNumber: 1,
      }
      const arr = this.state.fileArray
      arr.push({ name: fileName, size: file.size })
      let newarr = [...new Map(arr.map((item) => [item['name'], item])).values()]

      this.setState({
        fileName: file.name,
        fileArray: newarr,
      })
      getCurrentSession()
        .then((result) => {
          const { accessToken } = result
          return apigClient.preSignedURLPut(
            params,
            {},
            {
              headers: {
                Authorization: accessToken,
              },
            },
          )
        })
        .then((response) => {
          const formData = new FormData()
          formData.append('file', renamedFile)
          fetch(response.data, {
            method: 'put',
            body: formData,
            headers: {
              'Content-Type': 'application/pdf',
            },
          })
            .then((res) => {
              this.props.onFileChange({
                id: this.props.id,
                fileSize: file.size,
                fileArray: newarr,
                attached: true,
                valid: true,
                fileName: fileName,
              })
              this.setState({
                uploaded: true,
                loading: false,
                fileSize: file.size,
              })
            })
            .catch((err) => {
              console.log({ err })
              this.setState({
                uploaded: false,
                loading: false,
              })
              toastify.error(toastFileUploadRetryMessage)
            })
        })
        .catch((err) => {
          console.log({ err })
          this.setState({
            uploaded: false,
            loading: false,
          })
          toastify.error(toastFileUploadRetryMessage)
        })
    }
  }

  handleRemove(name) {
    this.setState({ removeName: name, deleteLoading: true })
    const params = {
      id: this.props.submissionID,
      revisionNumber: 1,
      fileName: this.props.id === 'miscellaneousDocs' ? name : this.props.fileName,
    }
    getCurrentSession()
      .then((result) => {
        const { accessToken } = result
        return apigClient.bindReportsDelete(
          params,
          {},
          {
            headers: {
              Authorization: accessToken,
            },
          },
        )
      })
      .then((response) => {
        var fileArray = this.state.fileArray || []
        if (this.props.id === 'miscellaneousDocs') {
          fileArray = fileArray.filter((k) => k.name !== name)
        }
        this.props.onFileChange({
          id: this.props.id,
          fileSize: 0,
          attached: false,
          valid: true,
          fileArray: fileArray,
        })

        this.setState({
          selected: false,
          fileName: '',
          uploaded: false,
          loading: false,
          file: null,
          removeName: '',
          deleteLoading: false,
          fileArray: fileArray,
        })
      })
      .catch((err) => console.log({ err }))
  }

  handleReload() {
    this.handleClick({ retry: true })
  }

  fileSizeHandler(cell, row, enumObject, rowIndex) {
    if (this.props.isFileLimitExceeded && rowIndex + 1 === this.state.fileArray.length) {
      return (
        <span style={{ color: 'red', fontSize: '12px' }}>
          {this.dataSizeFormatter(row.size)}
        </span>
      )
    } else {
      return <span style={{ fontSize: '12px' }}>{this.dataSizeFormatter(row.size)}</span>
    }
  }

  fileNameHandler = (cell, row) => {
    return <span style={{ fontSize: '12px' }}> {this.removeSuffix(row.name, 'MD')} </span>
  }

  handleDownload(name, row) {
    this.setState({ downloadName: name, downloadLoading: true })
    const params = {
      fileName: this.props.id === 'miscellaneousDocs' ? name : this.props.fileName,
      submissionID: this.props.submissionID,
      revisionNumber: 1,
    }
    getCurrentSession()
      .then((result) => {
        const { accessToken } = result
        return apigClient.preSignedURLGet(
          params,
          {},
          {
            headers: {
              Authorization: accessToken,
            },
          },
        )
      })
      .then((response) => {
        fetch(response.data, {
          method: 'get',
        })
          .then((res) => res.blob())
          .then((res) => {
            const fileName = this.removeSuffix(params.fileName, `_${this.props.suffix}`)
            saveByteArray(res, fileName, 'application/pdf')
            this.setState({ downloadName: '', downloadLoading: false })
          })
          .catch((err) => {
            console.log({ err })
          })
      })
      .catch((err) => {
        console.log({ err })
      })
  }

  formatActionColumn = (cell, row) => {
    return (
      <div style={{ marginLeft: '-10px ' }}>
        <button
          className="btn binder-icons"
          onClick={(event) => this.handleRemove(row.name, row)}
        >
          {row.name === this.state.removeName ? (
            <LoaderCircle size={14} />
          ) : (
            <X size={14} />
          )}
        </button>
        <button
          className="btn binder-icons"
          style={{ paddingLeft: '5px !important' }}
          onClick={(event) => this.handleDownload(row.name, row)}
        >
          {row.name === this.state.downloadName ? (
            <LoaderCircle size={14} />
          ) : (
            <Download size={14} />
          )}
        </button>
      </div>
    )
  }

  dataSizeFormatter(dataSize) {
    if (!dataSize) {
      return
    }
    const dataSizeUnits = ['Bytes', 'KB', 'MB']
    let index = 0
    while (index < dataSizeUnits.length - 1 && dataSize / 1024 > 1) {
      index++
      dataSize /= 1024
    }
    dataSize = Math.round(dataSize * 100) / 100
    return `${dataSize}${dataSizeUnits[index]}`
  }

  render() {
    const { selected, valid, loading, uploaded, fileName, fileSize, fileArray } =
      this.state

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return this.removeSuffix(row.name, 'MD')
    }

    return (
      <div className="row getdown mt_10">
        <div className="col-xs-4 bind-documents">{this.props.label}</div>
        <div className="col-xs-8 uploader">
          <div
            className="upload-btn-wrapper"
            style={{ color: selected && valid ? '' : 'red' }}
          >
            {this.props.id &&
              this.props.id === 'miscellaneousDocs' &&
              fileArray.length > 0 && (
                <div style={{width: '400px',overflowY:'auto'}}>
                  <BootstrapTable
                    data={fileArray}
                    maxHeight="140px"
                    maxWidth="40px"
                    scrollTop={'Top'}
                    bodyContainerClass="revision-table-body"
                  >
                    <TableHeaderColumn
                      dataField="name"
                      headerAlign="center"
                      dataAlign="center"
                      dataFormat={this.fileNameHandler}
                      columnTitle={columnHover}
                      hover={true}
                      width={'60%'}
                    >
                      Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="size"
                      headerAlign="center"
                      dataAlign="center"
                      dataFormat={this.fileSizeHandler}
                    >
                      File Size
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="key"
                      headerAlign="center"
                      dataAlign="center"
                      isKey
                      dataFormat={this.formatActionColumn}
                    >
                      Actions
                    </TableHeaderColumn>
                  </BootstrapTable>
                  {/* {this.state.isClicked && <PDFPreviewQuoteRevision pdfLink={this.props.PDFdata} revisionNo={this.state.revNo} custom_class="confirmationDialog" submissionid={this.state.subid} show={this.state.isClicked} onHide={this.handleHidePdf} />} */}
                </div>
              )}
            {this.props.id !== 'miscellaneousDocs' && fileName}
            {this.props.id !== 'miscellaneousDocs' &&
              fileName &&
              (this.props.isFileLimitExceeded ? (
                <span style={{ color: 'red', marginLeft: '10px' }}>
                  {this.dataSizeFormatter(fileSize)}
                </span>
              ) : (
                <span style={{ marginLeft: '10px' }}>
                  {this.dataSizeFormatter(fileSize)}
                </span>
              ))}
            {loading && (
              <button className="btn binder-icons">
                <LoaderCircle size={14} />
              </button>
            )}
            {selected && valid && !loading && this.props.id !== 'miscellaneousDocs' && (
              <button className="btn binder-icons" onClick={this.handleDownload}>
                {this.state.downloadLoading ? <LoaderCircle size={14} /> : <Download size={14}/>}
              </button>
            )}
            {selected &&
              valid &&
              !loading &&
              !uploaded &&
              this.props.id !== 'miscellaneousDocs' && (
                <button
                  className="btn binder-icons"
                  onClick={() => this.handleClick({ retry: true })}
                >
                  <Repeat size={14} />
                </button>
              )}
            {!selected && this.props.id !== 'miscellaneousDocs' && (
              <Button
                className="btn"
                disabled={this.props.isFileLimitExceeded}
                onClick={null}
              >
                Choose file
              </Button>
            )}
            {selected && !loading && this.props.id !== 'miscellaneousDocs' && (
              <button className="btn binder-icons" onClick={this.handleRemove}>
                {this.state.deleteLoading ? (
                  <LoaderCircle size={14} />
                ) : (
                  <X size={14} />
                )}
              </button>
            )}
            {this.props.id !== 'miscellaneousDocs' && selected == false ? (
              <input
                type="file"
                name={this.props.name}
                accept="application/pdf"
                onChange={this.handleClick}
              />
            ) : (
              ''
            )}
            {this.props.id === 'miscellaneousDocs' && (
              <label
                style={{ padding: '0px 10px 5px 10px' }}
                disabled={this.props.isFileLimitExceeded}
                className="btn"
              >
                <input
                  disabled={this.props.isFileLimitExceeded}
                  type="file"
                  multiple
                  style={{ position: 'relative', height: '0px', maxWidth: '0px' }}
                  name={this.props.name}
                  accept="application/pdf"
                  onChange={this.handleClick}
                />
                Choose file
              </label>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default FileInput
